module.exports = __webpack_public_path__ + "static/media/bg-girl1.6950222f.png";